module.exports = __webpack_public_path__ + "img/es.50623e6a.svg";